import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

/**
 * Provides a callback function which can be used to get to the url passed in
 * @param url the url to get from
 * @returns {{getCallback: ((function(): Promise<*>)), loading: boolean, error: boolean}}
 *
 * loading - true when post is currently happening.
 *
 * error - true when an error has occured.
 *
 * getCallback - the get callback function, returns a promise which will contain json from the response.
 */
export function useLazyFetchGetV2(url) {
  const { loading, error, fetchCallback } = useLazyFetchV2("GET");

  return {
    loading,
    error,
    getCallback: () =>
      fetchCallback(url, undefined, { "Content-Type": "application/json" })
  };
}
